import React from 'react';
import RichText from 'components/RichText';
import styled from '@emotion/styled';
import dimensions from 'styles/dimensions';
import colors from 'styles/colors';

const ContentContainer = styled.div`
  > * {
    & + * {
      margin-top: 4rem;
    }
    
    & + p {
      margin-top: 1.6rem;
    }
  }
  
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-weight: 500;
  }
  
  a {
    color: ${colors.red500};
    font-weight: 500;
    transition: color 0.08s ease-in-out;
    
    &:hover {
      color: ${colors.green400};
    }
  }
  
  ul, ol {
    list-style: initial;
    color: ${colors.teal800};
    font-size: 1.8rem;
    padding-left: 3.2rem;
   
    li {
      & + * {
        margin-top: 1.6rem;
      }
    } 
  }
  
  .block-img {
    margin: 4rem 0;
    
    img {
      display: block;
      max-width: 100%;
      margin: 0 auto;
    }
  }
  
  @media(min-width: ${dimensions.tabletLandscapeUp}px) {
    > * {
      & + * {
        margin-top: 4.8rem;
      }
    }
    
    .block-img {
      margin: 6.4rem 0;
    }
  }
`;

const Content = ({ content }) => {
  return (
    <ContentContainer>
      <RichText render={content}/>
    </ContentContainer>
  );
};

export default Content;
